import { format, isAfter, isBefore, parseISO } from 'date-fns'
import type { Group } from '@/features/stm/lib/types'

/** Trip range for calendar bars; partial dates collapse to a single day. */
export function tripDatesToSpan(
  start_date: string | null | undefined,
  end_date: string | null | undefined
): { from: Date; to: Date } | null {
  const sd = (start_date ?? '').trim().split('T')[0] ?? ''
  const ed = (end_date ?? '').trim().split('T')[0] ?? ''
  if (sd && ed) {
    const from = parseISO(sd)
    const to = parseISO(ed)
    if (isNaN(from.getTime()) || isNaN(to.getTime())) return null
    if (from > to) return null
    return { from, to }
  }
  if (sd && !ed) {
    const from = parseISO(sd)
    if (isNaN(from.getTime())) return null
    return { from, to: from }
  }
  if (!sd && ed) {
    const to = parseISO(ed)
    if (isNaN(to.getTime())) return null
    return { from: to, to }
  }
  return null
}

export function groupToTripSpan(g: Group): { from: Date; to: Date } | null {
  return tripDatesToSpan(g.start_date, g.end_date)
}

export function getTripParticipantCountForDay(
  groups: Array<{
    start_date: string | null
    end_date: string | null
    participants: number
    status?: string
  }>,
  day: Date
): { participantSum: number; groupCount: number } {
  if (!groups.length) return { participantSum: 0, groupCount: 0 }
  const dayStr = format(day, 'yyyy-MM-dd')
  const dayDate = parseISO(dayStr)
  let participantSum = 0
  let groupCount = 0
  for (const g of groups) {
    if (g.status === 'Cancelled') continue
    const span = tripDatesToSpan(g.start_date, g.end_date)
    if (!span) continue
    if (!isAfter(dayDate, span.to) && !isBefore(dayDate, span.from)) {
      participantSum += g.participants || 0
      groupCount += 1
    }
  }
  return { participantSum, groupCount }
}
